import FormC from "./Form";
import Foot from "./foot";
import Icons from "./icons";
import { IoIosCall } from "react-icons/io";

const Footer = () =>{
    return(
        <>
           <div id="contact">
             
        <div className="down" id="down">
            <h1 className="text-center">Contact Me</h1>
            <div className="form">
              <div className="left_content">
                <h2>I'm always interested in hearing about new projects, so if you'd like to chat please get in touch.
                <p><a href="tel:917070870833" className="call"><IoIosCall/></a> +91-7070870833</p>
                </h2>
                <Icons/>
              </div>
              <FormC/>
            </div>
            <Foot/>
        </div>
            </div>
        </>
    )
}
export default Footer